// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__2dngA","footer":"Form_footer__1v8ll"};